export default "__VITE_ASSET__Bs_el661__"